export {
  ECMA_SCRIPT_MEMBER_ACCESS_RULES as TSX_MEMBER_ACCESS_RULES,
} from './javascript.js';
